import { OrchardProvider, Typography } from "@codat/orchard-ui";
import { UserStateContextProvider } from "contexts/UserStateContext";

import {
  CreateUserManagementService,
  UserManagementServiceContext,
} from "pages/UserManagement/UserManagementService";

import styles from "./AccountSettings.module.css";
import { ChangePassword } from "./ChangePassword/ChangePassword";
import { UserDetails } from "./UserDetails/UserDetails";

export const AccountSettings = () => {
  const userManagementService = CreateUserManagementService();

  return (
    <section className={styles.page}>
      <UserManagementServiceContext.Provider value={userManagementService}>
        <UserStateContextProvider>
          <Typography variant="heading_xxl" as="h2">
            Account settings
          </Typography>
          <UserDetails />
          <ChangePassword />
        </UserStateContextProvider>
      </UserManagementServiceContext.Provider>
    </section>
  );
};

export const AccountSettingsRemote = () => (
  <OrchardProvider appId="account-settings">
    <AccountSettings />
  </OrchardProvider>
);
